import Button from './Button';
import React from 'react';

const CancelButton = ({ onClick }) => {
  return <Button text={'Cancel'} onClick={onClick} color={'red'} isInverse={true} />;
};

export default CancelButton;
